<template>
    <tr>
        <td>{{member.user.first_name}} {{member.user.last_name}}</td>

        <td>
            <base-select
                v-if="!member.is_owner && !member.is_space_admin"
                v-model="role"
                @input="save"
                :small="true"
                :options="roles"
                :loading="update.loading"
                :disabled="!space_permission('TOPIC_UPDATE', space)"
                option_label="label"
                option_value="value"/>

            <span v-else class="tag">{{role}}</span>
        </td>

        <td v-if="space_permission('TOPIC_UPDATE', space)">
            <span v-if="member.is_owner" class="tag is-light">owner</span>
            <span v-else-if="member.is_space_admin" class="tag is-light">space admin</span>

            <i v-else
               @click="show_confirm = true"
               class="icon fas fa-times-circle"></i>
        </td>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this member?"
            @close="show_confirm = false"
            @ok="remove"/>
    </tr>
</template>

<script>
import { mapState } from 'vuex';
import { roles } from '../../utils/constants';

export default {
    name: 'SpaceMembersItem',
    props: ['space', 'topic', 'member'],
    computed: {
        ...mapState('topic_members', ['update']),
    },
    data() {
        return { role: this.member.role, roles, show_confirm: false };
    },
    methods: {
        async remove() {
            await this.$store.dispatch('topic_members/remove', {
                space_id: this.space.id,
                topic_id: this.topic.id,
                member_id: this.member.id,
            });

            this.$store.commit('topic_members/remove_topic_member', { id: this.member.id });
        },
        async save() {
            await this.$store.dispatch('topic_members/update', {
                space_id: this.space.id,
                topic_id: this.topic.id,
                member_id: this.member.id,
                data: { is_active: true, role: this.role },
            });
        },
    },
};
</script>
